
const FellowshipWorshipGrowth = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <div
        className="relative w-full bg-cover bg-center h-[420px] flex items-center justify-center"
        style={{
          backgroundImage: "url('./images/fellowship-worship.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative text-center px-6 md:px-12 lg:px-20 max-w-4xl">
          <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-4">
            The Importance of Fellowship, Worship, and Growing Together in Faith
          </h1>
          <p className="text-gray-200 text-lg md:text-xl">
            Discover why communal faith practices strengthen individuals, families, and the church community.
          </p>
        </div>
      </div>
        
      <section className="body--container w-full px-4 py-10 md:px-12 lg:px-24 xl:px-32">
        <div className="mx-auto max-w-4xl text-gray-800 leading-relaxed">
          <p className="mb-6">
            Faith is not meant to be lived in isolation. While personal devotion and private prayer are essential, spiritual
            growth flourishes when believers gather together. Fellowship, worship, and shared experiences in faith are the pillars
            that strengthen both individuals and communities.
          </p>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              1. Fellowship: Strength in Community
            </h2>
            <p>
              Fellowship is more than social interaction; it is spiritual connection and mutual support among believers. Gathering
              allows Christians to encourage one another, hold each other accountable, and celebrate joys and milestones together.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              2. Worship: Experiencing God Collectively
            </h2>
            <p>
              Corporate worship magnifies faith, fosters unity, and provides spiritual renewal. Singing, praying, and praising
              God alongside fellow believers cultivates intimacy with God and reinforces that faith is meant to be shared.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              3. Growing Together: Spiritual Maturity and Discipleship
            </h2>
            <p>
              Learning, praying, and serving together accelerates spiritual growth. Christians gain wisdom, develop spiritual
              discipline, and serve as a unified force, ensuring that faith is dynamic, resilient, and deeply rooted.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              4. The Ripple Effect on Families and Communities
            </h2>
            <p>
              Fellowship, worship, and shared growth strengthen families and communities. Children see examples of lived faith,
              families engage together, and communities experience the love and service of united believers.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              5. Practical Ways to Cultivate Fellowship, Worship, and Growth
            </h2>
            <p>
              Join small groups or Bible studies, participate in corporate worship, volunteer together, and encourage mentorship.
              Active engagement in these practices strengthens both personal faith and the life of the church.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              Conclusion: United in Faith, Strong in Spirit
            </h2>
            <p>
              Fellowship, worship, and growing together sustain the Christian journey. By engaging with others, believers live out
              faith, strengthen bonds, and experience the fullness of God’s love and purpose. Faith truly thrives in community.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-12">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Fellowship</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Worship</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Spiritual Growth</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Community</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FellowshipWorshipGrowth;